import axios, { type AxiosResponse } from "axios";
import { EmployeeResultSchema, EmployeeItemSchema } from "@/schemas/index";
import type { EmployeeResultType, EmployeeItemType } from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceEmployeesApiType {
  fetchEmployees: (
    pageIndex: number,
    pageSize: number,
    search: string,
  ) => Promise<EmployeeResultType>;
  fetchEmployeeById: (id: EmployeeItemType["Id"]) => Promise<EmployeeItemType>;
  fetchCreateEmployee: (data: Partial<EmployeeItemType>) => Promise<boolean>;
  fetchUpdateEmployee: (data: Partial<EmployeeItemType>) => Promise<boolean>;
  fetchRemoveEmployee: (id: EmployeeItemType["Id"]) => Promise<boolean>;
}

export const serviceEmployeesApi: ServiceEmployeesApiType = {
  fetchEmployees: (pageIndex, pageSize, search) => {
    return axios
      .get(
        `${env.services.portal}/employees?pageIndex=${pageIndex}&pageSize=${pageSize}&query=${search || ""}`,
      )
      .then((response: AxiosResponse<unknown>) => {
        return EmployeeResultSchema.parse(response.data);
      });
  },

  fetchEmployeeById: (id) => {
    return axios
      .get(`${env.services.portal}/employees/${id}`)
      .then((response: AxiosResponse<unknown>) => {
        return EmployeeItemSchema.parse(response.data);
      });
  },

  fetchCreateEmployee: (data) => {
    return axios.post(`${env.services.portal}/employees`, data);
  },

  fetchUpdateEmployee: (data) => {
    return axios.patch(`${env.services.portal}/employees/${data?.Id}`, data);
  },

  fetchRemoveEmployee: (id) => {
    return axios.delete(`${env.services.portal}/employees/${id}`);
  },
};
